// Hooks
import { useMemo } from 'react';
import classNames from 'classnames';
import useVisible from '../../hooks/visible';

// Partials
import Icon from '../icon';

export const Loader = ({ loading, spinnerIcon, className, message, icon: iconProp, style: styleProp }) => {
	const [inView, visible] = useVisible(loading === undefined ? true : !!loading);

	const style = useMemo(() => (
		{
			display: 'none',
			...(styleProp ?? {}),
		}
	), [styleProp])

	if(inView) {
		return (
			<div
				style={style}
				className={classNames('loaderelem', className, { show: visible })}>
				{iconProp ?
					iconProp
					:
					<Icon className="loaderelem-icon" name={spinnerIcon} />
				}
				{message &&
					<div className="loaderelem-message">{message}</div>
				}
			</div>
		)
	}
}

Loader.defaultProps = {
	spinnerIcon: 'spinner',
	loading: undefined,
	className: '',
	message: false,
}